import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AppConstants } from '../_constants/constants';

@Injectable()
export class SellerProfileCompleteGuard implements CanActivate {

    constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Check if we're in browser environment
        const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';

        // For SSR: Allow access (server can't check localStorage)
        // Client-side auth check will happen after hydration
        if (!isBrowser) {
            return true;
        }

        const currentUserJson = localStorage.getItem(AppConstants.CURRENT_USER_KEY);
        const currentUser = currentUserJson ? JSON.parse(currentUserJson) : null;

        // If user is a seller and already has a complete profile, redirect to dashboard
        if (currentUser &&
            currentUser.role &&
            currentUser.role.toLowerCase() === 'seller' &&
            currentUser.seller != null) {
            this.router.navigate(['/user/dashboard'], { replaceUrl: true });
            return false;
        }

        // User either isn't a seller or has an incomplete profile - allow access to setup
        return true;
    }
}
